module.exports = __webpack_public_path__ + "static/img/loading.4ba6124.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = 230
// module chunks = 31